import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";

import Login from "../pages/Login.vue";
import middlewarePipeline from "./middlewarePipeline";
import auth from "./middlewares/auth";
import guest from "./middlewares/guest";

Vue.use(VueRouter);

const routes = [
    {
        path: "/app-pay",
        name: "AppPay",
        meta: {
            title: "AppPay",
            layout: "blank",
            middleware: [guest],
        },
        component: () => import("../pages/AppPay.vue"),
    },
    {
        path: "/",
        name: "Login",
        meta: {
            title: "Mydoc",
            // layout: 'blank',
            middleware: [guest],
        },
        component: Login,
    },
    {
        path: "/symptom-checker",
        name: "SymptomChecker",
        meta: {
            title: "Mydoc",
            // layout: 'blank',
            middleware: [guest],
        },
        component: () => import("../pages/SymptomChecker.vue"),
    },
    // {
    //   path: '/',
    //   name: 'Home',
    //   meta: {
    //     title: 'Mydoc',
    //     // layout: 'default',
    //     middleware: [guest]
    //   },
    //   component: () => import('../pages/Home.vue')
    // },
    {
        path: "/covid-19",
        name: "Covid",
        meta: {
            title: "Covid 19",
            // layout: 'blank',
            middleware: [guest],
        },
        component: () => import("../pages/Covid.vue"),
    },
    {
        path: "/test",
        name: "Test",
        meta: {
            title: "Mydoc",
            // layout: 'blank',
            middleware: [guest],
        },
        component: () => import("../pages/Test.vue"),
    },
    {
        path: "/register",
        name: "Register",
        meta: {
            title: "Registration",
            // layout: 'blank',
            middleware: [guest],
        },
        component: () => import("../pages/Register/Index.vue"),
    },
    {
        path: "/user-agreement",
        name: "UserAgreement",
        meta: {
            title: "UserAgreement",
            // layout: 'blank',
            middleware: [guest],
        },
        component: () => import("../pages/Agreement.vue"),
    },
    {
        path: "/notifications",
        name: "Notifications",
        meta: {
            title: "Notifications",
            middleware: [auth],
        },
        component: () => import("../pages/Notifications.vue"),
    },
    {
        path: "/dashboard",
        name: "Dashboard",
        meta: {
            title: "Dashboard",
            middleware: [auth],
        },
        component: () => import("../pages/Dashboard.vue"),
    },
    {
        path: "/doctors",
        name: "Doctors",
        meta: {
            title: "Doctors",
            middleware: [guest],
        },
        component: () => import("../pages/Doctors.vue"),
    },
    {
        path: "/doctor/:id",
        name: "Doctor",
        meta: {
            title: "Doctor",
            middleware: [guest],
        },
        component: () => import("../pages/Doctor.vue"),
    },
    {
        path: "/services",
        name: "Services",
        meta: {
            title: "Services",
            middleware: [guest],
        },
        component: () => import("../pages/Services.vue"),
    },
    {
        path: "/service/:id",
        name: "Service",
        meta: {
            title: "Service",
            middleware: [guest],
        },
        component: () => import("../pages/Service.vue"),
    },
    {
        path: "/clinic-doctors",
        name: "ClinicDoctors",
        meta: {
            title: "ClinicDoctors",
            middleware: [auth],
        },
        component: () => import("../pages/ClinicDoctors.vue"),
        children: [
            {
                path: ":id",
                name: "ClinicDoctor",
                meta: {
                    title: "ClinicDoctor",
                    middleware: [auth],
                },
                component: () => import("../pages/ClinicDoctor.vue"),
            },
        ],
    },
    {
        path: "/my",
        name: "My",
        meta: {
            title: "My",
            middleware: [auth],
        },
        component: () => import("../pages/My/Index.vue"),
        children: [
            {
                path: "schedule",
                name: "MySchedule",
                meta: {
                    title: "MySchedule",
                    middleware: [auth],
                },
                component: () => import("../pages/My/Schedule.vue"),
            },
            {
                path: "schedule-manager",
                name: "ScheduleManager",
                meta: {
                    title: "ScheduleManager",
                    middleware: [auth],
                },
                component: () => import("../pages/My/ScheduleManager.vue"),
            },
        ],
    },
    {
        path: "/profile",
        meta: {
            title: "Profile",
            middleware: [auth],
        },
        component: () => import("../pages/Profile/Index.vue"),
        children: [
            {
                path: "/",
                name: "Profile",
                meta: {
                    title: "Profile",
                    middleware: [auth],
                },
                component: () => import("../pages/Profile/Profile.vue"),
            },
            {
                path: "personal-info",
                name: "PersonalInfo",
                component: () => import("../pages/Profile/PersonalInfo.vue"),
                meta: {
                    title: "PersonalInfo",
                    middleware: [auth],
                },
            },
            {
                path: "password",
                name: "ChangePassword",
                component: () => import("../pages/Profile/Password.vue"),
                meta: {
                    title: "ChangePassword",
                    middleware: [auth],
                },
            },
        ],
    },
    {
        path: "/p",
        meta: {
            title: "Patient",
            middleware: [auth],
        },
        component: () => import("../pages/P/Index.vue"),
        children: [
            {
                path: "/",
                name: "Patient",
                meta: {
                    title: "Patient",
                    middleware: [auth],
                },
                component: () => import("../pages/P/Patient.vue"),
            },
            {
                path: "cases",
                name: "cases",
                component: () => import("../pages/P/Cases.vue"),
                meta: {
                    title: "cases",
                    middleware: [auth],
                },
            },
            {
                path: "case/:id",
                name: "case",
                component: () => import("../pages/P/Case.vue"),
                meta: {
                    title: "case",
                    middleware: [auth],
                },
            },
            {
                path: "interviews",
                name: "interviews",
                component: () => import("../pages/P/Interviews.vue"),
                meta: {
                    title: "interviews",
                    middleware: [auth],
                },
            },
            {
                path: "checkups",
                name: "Checkups",
                meta: {
                    title: "Checkups",
                    middleware: [auth],
                },
                component: () => import("../pages/P/Checkups.vue"),
            },
            {
                path: "checkup/:id",
                name: "Checkup",
                meta: {
                    title: "Checkup",
                    middleware: [auth],
                },
                component: () => import("../pages/P/Checkup.vue"),
            },
            {
                path: "monitoring",
                name: "monitoring",
                component: () => import("../pages/P/Monitoring.vue"),
                meta: {
                    title: "monitoring",
                    middleware: [auth],
                },
            },
        ],
    },
    {
        path: "/chats",
        name: "Chats",
        meta: {
            title: "Chats",
            middleware: [auth],
        },
        component: () => import("../pages/Chats/Chats.vue"),
        children: [
            {
                path: ":id",
                name: "Chat",
                component: () => import("../pages/Chats/Chat.vue"),
                meta: {
                    title: "Chat",
                    middleware: [auth],
                },
            },
            {
                path: ":id/call",
                name: "ChatCall",
                component: () => import("../pages/Chats/Chat.vue"),
                meta: {
                    title: "Call",
                    middleware: [auth],
                },
            },
        ],
    },
    {
        path: "/schedules",
        name: "Schedule",
        meta: {
            title: "Schedule",
            middleware: [auth],
        },
        component: () => import("../pages/Schedules/Index.vue"),
    },
    {
        path: "/schedules/:id",
        name: "Schedule",
        meta: {
            title: "Schedule",
            middleware: [auth],
        },
        component: () => import("../pages/Schedules/Schedule.vue"),
    },
    {
        path: "/cadmin",
        name: "Clinic Administration",
        meta: {
            title: "Clinic Administration",
            middleware: [auth],
        },
        component: () => import("../pages/CAdmin/Main.vue"),
    },
    {
        path: "/cadmin/doctors",
        name: "Clinic Administration - Doctors",
        meta: {
            title: "Clinic Administration - Doctors",
            middleware: [auth],
        },
        component: () => import("../pages/CAdmin/Doctors.vue"),
    },
    {
        path: "/cadmin/services",
        name: "Clinic Administration - Services",
        meta: {
            title: "Clinic Administration - Services",
            middleware: [auth],
        },
        component: () => import("../pages/CAdmin/Services.vue"),
    },
    {
        path: "/clinics",
        name: "Clinics",
        meta: {
            title: "Clinics",
            middleware: [auth],
        },
        component: () => import("../pages/Clinics/Clinics.vue"),
        children: [
            {
                path: ":id",
                name: "Clinic",
                component: () => import("../pages/Clinics/Clinic.vue"),
                meta: {
                    title: "Clinic",
                    middleware: [auth],
                },
            },
            {
                path: ":id/inquiry",
                name: "ClinicInquiry",
                component: () => import("../pages/Clinics/Inquiry.vue"),
                meta: {
                    title: "Clinic",
                    middleware: [auth],
                },
            },
        ],
    },
    {
        path: "/patient/register",
        name: "RegisterPatient",
        meta: {
            title: "Register Patient",
            middleware: [auth],
        },
        component: () => import("../pages/Patients/Register.vue"),
    },
    {
        path: "/patients",
        name: "ClinicPatients",
        meta: {
            title: "Patients",
            middleware: [auth],
        },
        component: () => import("../pages/Patients/Patients.vue"),
        children: [
            {
                path: ":id",
                name: "ClinicPatient",
                component: () => import("../pages/Patients/Patient.vue"),
                meta: {
                    title: "Patient",
                    middleware: [auth],
                },
            },
        ],
    },
    {
        path: "/cases",
        name: "Cases",
        meta: {
            title: "Cases",
            middleware: [auth],
        },
        component: () => import("../pages/Cases/Cases.vue"),
    },
    {
        path: "/cases/:id/report",
        name: "CaseReport",
        meta: {
            title: "Cases",
            layout: "blank",
            middleware: [auth],
        },
        component: () => import("../pages/Cases/Report.vue"),
    },
    {
        path: "/interview/:id?",
        name: "SymptomChecker",
        meta: {
            title: "SymptomChecker",
            middleware: [guest],
        },
        component: () => import("../pages/Interview.vue"),
    },
    {
        path: "*",
        name: "404*",
        meta: {
            layout: "blank",
        },
        component: require("@/pages/404.vue").default, // load sync home
    },
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
});
router.beforeEach((to, from, next) => {
    if (!to.meta.middleware) {
        return next();
    }
    const cookie = Vue.cookie;
    const middleware = to.meta.middleware;
    const context = {
        to,
        from,
        next,
        store,
        cookie,
        Vue,
    };

    return middleware[0]({
        ...context,
        next: middlewarePipeline(context, middleware, 1),
    });
});

export default router;
